import('./StandaloneApp');
